"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shade = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _shadeClasses = require("./shadeClasses");
var _styles = require("./styles");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
const Shade = ({
  shade,
  currentShade,
  size = _types.ShadeSize.Medium,
  testId,
  onShadeClick,
  className
}) => {
  const rootClassName = (0, _clsx.default)(_shadeClasses.shadeClasses.root, className);
  const onClick = (0, _react.useCallback)(() => {
    onShadeClick?.(shade);
  }, [onShadeClick, shade]);
  const onKeyDown = (0, _react.useCallback)(event => {
    if (event.key === 'Enter') {
      onClick();
    }
  }, [onClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadeRoot, {
    className: rootClassName,
    currentShade: currentShade,
    isClickable: onShadeClick !== undefined,
    shade: shade,
    size: size,
    "data-testid": testId,
    tabIndex: size === _types.ShadeSize.Medium ? 0 : undefined,
    role: "button",
    onKeyDown: onKeyDown,
    onClick: onClick,
    children: shade.canBeSold ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadeClearIcon, {
      shade: shade,
      size: size,
      className: _shadeClasses.shadeClasses.clearIcon
    })
  });
};
exports.Shade = Shade;
//# sourceMappingURL=Shade.js.map